import { ApiClientError } from '@/lib/api/client'

const FALLBACK_MESSAGE = 'Não foi possível concluir esta ação. Tente novamente.'

const ENGLISH_TO_PT: Record<string, string> = {
  'No spins available.': 'Você não tem giros disponíveis no momento.',
  'Campaign does not grant spins for sharing.': 'Esta campanha não concede giros ao compartilhar.',
  'Campaign has no roulette prizes configured.': 'A roleta desta campanha ainda não tem prêmios configurados.',
  'Roulette config must be created before setting prizes.':
    'Salve a configuração da roleta antes de definir os prêmios.',
  'Invalid prize_type. Must be coupon, lucky_number, pix, or none.':
    'Tipo de prêmio inválido. Use cupom, número da sorte, PIX ou sem prêmio.',
  'Roulette config not found for this campaign.': 'A roleta desta campanha ainda não foi configurada.',
  'Roulette not configured for this campaign.': 'A roleta desta campanha não está disponível.',
  'Prize not found.': 'Prêmio não encontrado.',
  'Donor not found.': 'Comprador não encontrado.',
  'Campaign not found.': 'Campanha não encontrada.',
  'Insufficient spins.': 'Você não tem giros suficientes para girar agora.',
  'Donor does not belong to this campaign institution.': 'Você não pode usar a roleta desta campanha.',
  'Coupon code cannot be empty.': 'Informe o código do cupom.',
  'Invalid coupon code, coupon already used, or coupon does not belong to this campaign.':
    'Este cupom é inválido, já foi usado ou não pertence a esta campanha.',
  'This coupon has no discount configured.': 'Este cupom não tem desconto configurado.',
  'The given data was invalid.': 'Não foi possível validar os dados. Confira as informações e tente novamente.',
  'Validation failed.': 'Não foi possível validar os dados. Confira as informações e tente novamente.',
  Unauthenticated: 'Sua sessão expirou. Entre novamente para continuar.',
  'Unauthenticated.': 'Sua sessão expirou. Entre novamente para continuar.',
  'Server Error': 'Ocorreu um erro interno. Tente novamente em instantes.',
  Forbidden: 'Você não tem permissão para esta ação.',
  'Forbidden.': 'Você não tem permissão para esta ação.',
  'Http error.': 'Não foi possível concluir esta ação. Tente novamente.',
  'Token de doador ausente.': 'Entre na campanha para girar a roleta.',
}

function translateKnownEnglish(message: string): string {
  const trimmed = message.trim()
  if (ENGLISH_TO_PT[trimmed]) {
    return ENGLISH_TO_PT[trimmed]
  }

  if (/^Each position must be between 1 and \d+\.$/.test(trimmed)) {
    return 'Cada posição da roleta precisa estar dentro da quantidade configurada.'
  }

  if (/^Roulette probabilities must sum to 1\.0/.test(trimmed)) {
    return 'As chances das fatias da roleta precisam somar 100%.'
  }

  if (/^Minimum purchase of R\$ /.test(trimmed)) {
    return trimmed.replace(
      /^Minimum purchase of R\$ (.+) required to use this coupon\.$/,
      'A compra mínima para usar este cupom é de R$ $1.'
    )
  }

  if (/^Unexpected token|^JSON\.parse|Failed to fetch|NetworkError/i.test(trimmed)) {
    return FALLBACK_MESSAGE
  }

  return trimmed
}

function firstValidationMessage(errors: Record<string, string[]> | undefined): string | null {
  if (!errors) return null
  const first = Object.values(errors).flat()[0]
  return typeof first === 'string' && first.trim() !== '' ? first.trim() : null
}

/**
 * Mensagem visível ao usuário para falhas da roleta/cupom: prioriza `errors` da API e evita inglês cru.
 */
export function formatRouletteUserError(err: unknown): string {
  if (err instanceof ApiClientError) {
    const fromErrors = firstValidationMessage(err.errors)
    if (fromErrors) {
      return translateKnownEnglish(fromErrors)
    }
    if (err.message.trim() !== '') {
      return translateKnownEnglish(err.message)
    }
  }

  if (err && typeof err === 'object' && 'message' in err && typeof (err as Error).message === 'string') {
    const message = (err as Error).message.trim()
    if (message !== '') {
      return translateKnownEnglish(message)
    }
  }

  return FALLBACK_MESSAGE
}
